/* Copyright 2017 Vmware, Inc. All rights reserved. -- Vmware Confidential */
namespace common_ui {
   /*
    * NOTE - vaivanov - This class should not be moved to Angular. It only contains storage baseline
    * related constants which are already provided by storage-baseline.service.ts
    *
    * There are also 2 other constants defined which do not seem to be used anywhere:
    *    BASIC_MODE and ADVANCED_MODE
    */
   export class StorageSelectorConstants {
      public static $inject = [
         "i18nService"
      ];

      public readonly STANDARD_STORAGE_BASELINE: StorageBaseline = {
         label: "na",
         id: "stdBaseline"
      };
      public readonly PMEM_STORAGE_BASELINE: StorageBaseline = {
         label: "na",
         id: "pmemBaseline"
      };
      public readonly VSAN_PMEM_STORAGE_BASELINE: StorageBaseline = {
         label: "na",
         id: "vsanPmemBaseline"
      };
      public readonly HYBRID_STORAGE_BASELINE: StorageBaseline = {
         label: "na",
         id: "hybridBaseline"
      };

      public readonly BASIC_MODE = "basicMode";
      public readonly ADVANCED_MODE = "advancedMode";

      constructor(
         private i18nService: any
      ) {
         this.STANDARD_STORAGE_BASELINE.label =
               i18nService.getString("Common", "storageSelector.stdBaseline.label");

         this.PMEM_STORAGE_BASELINE.label =
               i18nService.getString("Common", "storageSelector.pmemBaseline.label");

         this.VSAN_PMEM_STORAGE_BASELINE.label =
               i18nService.getString("Common", "storageSelector.vsanPmemBaseline.label");

         this.HYBRID_STORAGE_BASELINE.label =
               i18nService.getString("Common", "storageSelector.hybridBaseline.label");
      }

   } // class StorageSelectorConstants

   angular.module("com.vmware.platform.ui").service(
         "storageSelectorConstants", StorageSelectorConstants);

} // namespace
